export default __webpack_public_path__ + "static/media/3_Pilot_Project_banner.b130f6f9.png";